import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.Situations;

export const statusSelector = createSelector(rootSelector, (situations) => situations.status);

export const errorSelector = createSelector(rootSelector, (situations) => situations.error);

const situationsSelector = createSelector(rootSelector, (situations) => situations.data);

export default {
  statusSelector,
  errorSelector,
  situationsSelector,
};
